/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type RefreshInput = {|
  token?: ?string,
  clientMutationId?: ?string,
|};
export type authRefreshMutationVariables = {|
  input: RefreshInput
|};
export type authRefreshMutationResponse = {|
  +refreshToken: ?{|
    +token: string,
    +payload: any,
  |}
|};
export type authRefreshMutation = {|
  variables: authRefreshMutationVariables,
  response: authRefreshMutationResponse,
|};
*/


/*
mutation authRefreshMutation(
  $input: RefreshInput!
) {
  refreshToken(input: $input) {
    token
    payload
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "RefreshInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RefreshPayload",
    "kind": "LinkedField",
    "name": "refreshToken",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "token",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "payload",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "authRefreshMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "authRefreshMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "authRefreshMutation",
    "operationKind": "mutation",
    "text": "mutation authRefreshMutation(\n  $input: RefreshInput!\n) {\n  refreshToken(input: $input) {\n    token\n    payload\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '9a56791410e89a625739f4939f70ac5b';

module.exports = node;
